const mfa = {
    totp: 'Authenticator app OTP',
    webauthn: 'Passkey',
    backup_code: 'Backup code',
    email_verification_code: 'Email verification code',
    phone_verification_code: 'SMS verification code',
    link_totp_description: 'E.g., Google Authenticator, etc.',
    link_webauthn_description: 'Link your device or USB hardware',
    link_backup_code_description: 'Generate a backup code',
    link_email_verification_code_description: 'Link your email address',
    link_email_2fa_description: 'Link your email address for 2-step verification',
    link_phone_verification_code_description: 'Link your phone number',
    link_phone_2fa_description: 'Link your phone number for 2-step verification',
    verify_totp_description: 'Enter the one-time code in app',
    verify_webauthn_description: 'Verify your device or USB hardware',
    verify_backup_code_description: 'Paste the backup code you saved',
    verify_email_verification_code_description: 'Enter the code sent to your email',
    verify_phone_verification_code_description: 'Enter the code sent to your phone',
    send_to_email: 'Send to {{identifier}}',
    send_to_phone: 'Send to {{identifier}}',
    onboarding: 'Turn on 2-step verification',
    onboarding_description: 'Protect your account with 2-step verification. Choose one or more methods: Passkey, authenticator app (OTP), SMS verification code, or backup codes.',
    enable_mfa: 'Enable 2-step verification',
    add_mfa_factors: 'Add 2-step verification',
    add_mfa_description: 'Two-factor verification is enabled. Select your second verification method for secure sign-in.',
    add_another_mfa_factor: 'Add another 2-step verification',
    add_another_mfa_description: 'Select another way to add for verifying your identity when sign-in.',
    verify_mfa_factors: '2-step verification',
    verify_mfa_description: '2-step verification has been enabled for this account. Please select the second way to verify your identity.',
    add_authenticator_app: 'Add authenticator app',
    replace_authenticator_app: 'Replace authenticator app',
    step: 'Step {{step, number}}: {{content}}',
    scan_qr_code: 'Scan this QR code',
    scan_qr_code_description: 'Scan the following QR code with your authenticator app, such as Google Authenticator, Duo Mobile, Authy, etc.',
    qr_code_not_available: 'Can’t scan the QR code?',
    copy_and_paste_key: 'Copy and paste the key',
    copy_and_paste_key_description: 'Copy and paste the following key into your authenticator app, such as Google Authenticator, Duo Mobile, Authy, etc.',
    want_to_scan_qr_code: 'Want to scan QR code?',
    enter_one_time_code: 'Enter the one-time code',
    enter_one_time_code_link_description: 'Enter the 6-digit verification code generated by the authenticator app.',
    enter_one_time_code_description: '2-step verification has been enabled for this account. Please enter the one-time code shown on your linked authenticator app.',
    enter_email_verification_code: 'Enter Email verification code',
    enter_email_verification_code_description: '2-step authentication has been enabled for this account. Please enter the email verification code sent to {{identifier}}.',
    enter_phone_verification_code: 'Enter SMS verification code',
    enter_phone_verification_code_description: '2-step authentication has been enabled for this account. Please enter the SMS verification code sent to {{identifier}}.',
    link_another_mfa_factor: 'Switch to another method',
    save_backup_code: 'Save your backup code',
    save_backup_code_description: 'You can use one of these backup code to access your account if you have trouble during 2-step verification in another ways. Each code may be used only once.',
    backup_code_hint: 'Make sure copy them and save in a safe place.',
    new_backup_codes_generated: 'New backup codes have replaced your old codes. Save them in a safe place as soon as possible.',
    enter_a_backup_code: 'Enter a backup code',
    enter_backup_code_description: 'Enter the backup code you saved when the 2-step verification was initially enabled.',
    create_a_passkey: 'Create a passkey',
    create_passkey_description: 'Register your passkey using device biometrics, security keys (e.g., YubiKey), or other available methods.',
    try_another_verification_method: 'Try another method to verify',
    verify_via_passkey: 'Verify via passkey',
    verify_via_passkey_description: 'Use passkey to verify by your device password or biometrics, scanning QR code, or using USB security key like YubiKey.',
    trust_this_device_one: 'Trust this device for {{count}} day',
    trust_this_device_two: 'Trust this device for {{count}} days',
    trust_this_device_few: 'Trust this device for {{count}} days',
    trust_this_device_many: 'Trust this device for {{count}} days',
    trust_this_device_other: 'Trust this device for {{count}} days',
    secret_key_copied: 'Secret key copied.',
    backup_code_copied: 'Backup code copied.',
    webauthn_not_ready: 'WebAuthn is not ready yet. Please try again later.',
    webauthn_not_supported: 'WebAuthn is not supported in this browser.',
    webauthn_failed_to_create: 'Failed to create. Please try again.',
    webauthn_failed_to_verify: 'Failed to verify. Please try again.',
};
export default Object.freeze(mfa);
